// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"0bc1cfab","319":"2bcda660","418":"1184c6d5","925":"a85629d4"}[chunkId] + ".chunk.css";
};